<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    <div class="content">
                        <div class="applet-wrap">
                            <p>问：湖南省执业药师继续教育专业科目考试端口如何进入？</p>
                            <p>答：长按识别以下“湖南省药师考核”微信小程序二维码，进入专业科目考试端口。该登录密码与湖南省药师教育管理平台的登录密码相同。</p>
                            <h3>“湖南省药师考核”微信小程序二维码</h3>
                            <img src="../../assets/images/yaos_applet.jpg" alt="">
                       </div>
                    </div>
                </section>
            </el-main>
        </el-container>
    </el-container>

</template>
<script>
import commonheader from "../common/commonHeader.vue"; //头部组件
import leftMenu from "../common/leftMenu.vue"; //头部组件
import exit from "../common/exit.vue"; //头部组件
export default {
    name: 'studentsNote',
    components: {
        commonheader,
        leftMenu,
        exit
    },
    data(){
        return {
            // content:'',
            // loading:true
        }
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
    }
}
</script>

<style lang="stylus" scoped>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding 47px 57px 0 86px
    flex 1
    border-top 10px solid #f8f8f8
    border-left 10px solid #f8f8f8
    .applet-wrap
        overflow hidden
        padding-bottom 80px
        p
            font-size 16px
            color #333
            line-height 30px
</style>


// WEBPACK FOOTER //
// src/components/my/assessment.vue